import classNames from 'classnames'
import { BsGrid, BsXLg } from 'react-icons/bs'
import { useDispatch, useSelector } from 'react-redux'
import { Link, NavLink } from 'react-router-dom'
import { toggleMenu } from 'src/redux/global/menuSlice'
import NavbarMobile from './NavbarMobile'

const Navbar = () => {

  const dispatch = useDispatch()
  const stateMenu = useSelector(state => state.menu)

  const handleClickMenu = () => {
    dispatch(toggleMenu(!stateMenu.value))
  }

  const closeMenu = () => {
    dispatch(toggleMenu(false))
  }

  const ClassInActive = classNames({
    'text-primary font-normal relative': true
  })

  const ClassActive = classNames({
    'text-primary font-normal relative activeMenu': true
  })

  return (
    <>
      <div className='bg-[#F6F7F9] sticky top-0 z-[999] shadow-sm'>

        <div className='px-4 md:px-8 h-[72px] md:h-[112px] flex items-center'>

          {/* Logo */}
          <div className='w-[96px] md:w-[132px] md:ml-8'>
            <Link to='/'>
              <img
                className='w-full'
                src='/logo/logo-full.png'
                alt='abidin logo'
              />
            </Link>
          </div>

          <div className='flex-1 flex items-center justify-end gap-[40px]'>

            {/* Desktop Menu */}
            <div className='hidden md:flex gap-[40px]'>

              <NavLink
                to='/'
                className={({ isActive }) =>
                  isActive ? ClassActive : ClassInActive
                }
              >
                Home
              </NavLink>

              <NavLink
                to='/gallery'
                className={({ isActive }) =>
                  isActive ? ClassActive : ClassInActive
                }
              >
                Project
              </NavLink>

              <NavLink
                to='/services'
                className={({ isActive }) =>
                  isActive ? ClassActive : ClassInActive
                }
              >
                Service
              </NavLink>

              <NavLink
                to='/product'
                className={({ isActive }) =>
                  isActive ? ClassActive : ClassInActive
                }
              >
                Brands
              </NavLink>

              <NavLink
                to='/articles'
                className={({ isActive }) =>
                  isActive ? ClassActive : ClassInActive
                }
              >
                Article
              </NavLink>

              <NavLink
                to='/Request'
                className={({ isActive }) =>
                  isActive ? ClassActive : ClassInActive
                }
              >
                Request
              </NavLink>

            </div>

            {/* Desktop Contact Button */}
            <div className='hidden md:flex'>
              <a
                target='_blank'
                rel='noopener noreferrer'
                href='https://api.whatsapp.com/send?phone=6289507085550&text=Hai! saya ingin menanyakan tentang servis dan produk dari Angkasa Multimedia Solusi.'
                className='py-3 px-6 border border-primary text-primary rounded-full hover:bg-primary hover:text-white duration-300'
              >
                Contact Us
              </a>
            </div>

            {/* Mobile Hamburger */}
            <button
              onClick={handleClickMenu}
              className='md:hidden text-primary'
            >
              {stateMenu.value ? (
                <BsXLg size={22} />
              ) : (
                <BsGrid size={26} />
              )}
            </button>

          </div>
        </div>
      </div>

      {/* Separate Mobile Navbar */}
      <NavbarMobile
        isOpen={stateMenu.value}
        closeMenu={closeMenu}
      />

    </>
  )
}

export default Navbar